module.exports = __webpack_public_path__ + "static/media/ic_incomingCall.dc7111e5.svg";